import styled from 'styled-components';

export const BrownSection = styled.section`
    background: linear-gradient(137deg, rgba(255,230,235,1) 35%, rgba(233,229,255,1) 100%);
    margin: auto;
    padding-top: 120px;
    padding-bottom: 120px;
    text-align: center;

@media (max-width: 687px) {
    display: none;
}`